import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { SalesOrderContractTaskEditForm } from '@/components/features/tasks/sales_order_contract/[sales_order_contract_task_id]/SalesOrderContractTaskEditForm';

export const ApprovalSalesOrderContractTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();
  useEffect(() => setTitle(`Approval - Edit Sales Order Contract Task`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `Approval`, path: `/w/${_w_!.identifier}/approval` },
        {
          label: `Approval - Sales Order Contract Task Detail`,
          path: `/w/${_w_!.identifier}/approval/teams/${_t_!.id}/sales_orders/${_so_!.id}/sales_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <SalesOrderContractTaskEditForm />
    </WorkspaceLayout>
  );
};
